import { DashboardCard, OrderStatus } from "../models/dashboard.model";

 export const orderStatuses: OrderStatus[] = [
    { key: '', label: 'Total Shipment', class: 'shipment', description: 'Total Shipment' },
    { key: 'delivered', label: 'Delivered', class: 'delivered', percentageKey: true, description: 'Delivered Package' },
    { key: 'returned', label: 'Returned', class: 'returned', percentageKey: true, description: 'Returned Package' },
    { key: 'return_process', label: 'On Process Return', class: 'process-return', percentageKey: true, description: 'On Process Return' },
    { key: 'delivery', label: 'On Process Delivery', class: 'process-delivery', percentageKey: true, description: 'On Process Delivery' }
  ];

 export const cards: DashboardCard[] = [
    {
      title: 'Total Shipment',
      value: 0,
      color: 'blue',
      icon: 'https://storage.googleapis.com/komerce/assets/icons/box-blue.svg',
    },
    {
      title: 'Delivered Package',
      value: 0,
      color: 'green',
      icon: 'https://storage.googleapis.com/komerce/assets/icons/box-tick-green.svg',
      footer: {
        label: 'Total Cashback Shipment:',
        value: 0,
      },
    },
    {
      title: 'On Process Delivery Package',
      value: 0,
      color: 'yellow',
      icon: 'https://storage.googleapis.com/komerce/assets/icons/box-yellow.svg',
      footer: {
        label: 'Total Cashback Shipment:',
        value: 0,
      },
    },
    {
      title: 'Returned',
      value: 0,
      color: 'red',
      icon: 'https://storage.googleapis.com/komerce/assets/icons/box-remove-red.svg',
      footer: {
        label: 'On Process Return:',
        value: 0,
        isCurrency: false, // Explicitly false for counts
      },
    },
  ];

  export const cardsPayment: DashboardCard[] = [
    {
      title: 'Total Revenue',
      value: 0,
      color: 'green',
      isCurrency: true,
      icon: 'https://storage.googleapis.com/komerce/assets/icons/moneys-green.svg',
    },
    {
      title: 'Total Transaction',
      value: 0,
      color: 'blue',
      icon: 'https://storage.googleapis.com/komerce/assets/icons/convert-3d-cube-blue.svg',
    },
  ];


  export const cardsQrisly: DashboardCard[] = [
    {
      title: 'Total Generated',
      value: 0,
      color: 'gray',
      icon: 'https://storage.googleapis.com/komerce/assets/icons/code-gray.svg',
    },
    {
      title: 'Total Amount',
      value: 0,
      color: 'yellow',
      isCurrency: true,
      icon: 'https://storage.googleapis.com/komerce/assets/icons/chart-2-yellow.svg',
    },
  ];
